<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Project Settings</p>
        </header>
        <section class="modal-card-body">
            <b-field horizontal label="Name">
                {{ project.name }}
            </b-field>
            <b-field horizontal label="Owner">
                {{ project.createdBy }}
            </b-field>
            <b-field horizontal label="State">
                <span class="tag" :class="projectServiceHelper.getStateStyle(project.state)">{{ project.state }}</span>
            </b-field>
            <b-field horizontal label="Created">
                {{project.created | formatDate}}
            </b-field>
            <b-field horizontal label="Conversation Topic" class="settingsDescription" v-if="project.settings.conversationTopic">
                {{project.settings.conversationTopic.name}}
            </b-field>
            <b-field horizontal label="Description" class="settingsDescription" v-if="project.settings.description">
                {{project.settings.description}}
            </b-field>
            <b-field horizontal label="First day of the week">
                <b-field>
                    <b-radio-button v-model="firstDayWeek" native-value="saturday">
                        Saturday
                    </b-radio-button>
                    <b-radio-button v-model="firstDayWeek" native-value="sunday">
                        Sunday
                    </b-radio-button>
                    <b-radio-button v-model="firstDayWeek" native-value="monday">
                        Monday
                    </b-radio-button>
                </b-field>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <button type="button" class="button" @click="close">Close</button>
            <button type="button" class="button is-primary" @click="save">Accept Settings</button>
        </footer>
    </div>
</template>

<script>
import constants from '@/constants.js';
import { projectServiceHelper } from '@/services/project-service-helper.js';

const defaultFirstDayWeek = constants.DAY.MONDAY;

export default {
    name: 'ProjectSettings',
    props: {
        project: {
            type: Object,
            required: false
        }
    },
    data () {
        return {
            projectServiceHelper,
            errorMessage: '',
            firstDayWeek: defaultFirstDayWeek,
            isLoading: true
        };
    },
    created () {
        this.isLoading = false;
    },
    mounted () {
        const config = (this.project.settings && this.project.settings.config) || {};
        this.firstDayWeek = [constants.DAY.SATURDAY, constants.DAY.SUNDAY, constants.DAY.MONDAY]
            .includes(config.firstDayWeek) ? config.firstDayWeek : defaultFirstDayWeek;
    },
    methods: {
        save () {
            this.$emit('projectSaved', {
                firstDayWeek: this.firstDayWeek
            });
            this.$parent.close();
        },
        close () {
            this.$parent.close();
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-card {
    .settingsDescription {
        span {
            width: 100%;
            display: inline-flex;
        }
    }
}
.modal-card-foot {
    justify-content: flex-end;
}
</style>
